import { EligibilityConsentActions } from './applicationEligibility/EligibilityConsentActions'
import type { ApplicationEligibilitySectionProps } from './applicationEligibility/types'

export function ApplicationEligibilitySection({
  isSubmitting,
  isTermsAcceptedDisabled,
  termsAccepted,
  termsAcceptedError,
  onRegister,
  onTermsAcceptedChange,
}: ApplicationEligibilitySectionProps) {
  return (
    <section className="py-8">
      <EligibilityConsentActions
        checked={termsAccepted}
        error={termsAcceptedError}
        isSubmitting={isSubmitting}
        onChange={onTermsAcceptedChange}
        onRegister={onRegister}
        registerDisabled={isSubmitting}
        disabled={isTermsAcceptedDisabled}
      />
    </section>
  )
}
